import React, { useContext } from "react";
import { Table } from "../../view/Table";
import { debug } from "../../utils";
import { connect } from "react-redux";
import DeviceDetailsTableRow from "./DeviceDetailsTableRow";
import DeviceDetailsTableRowSkeleton from "./DeviceDetailsTableRowSkeleton";
import { useViolationsTableHelper } from "../../violations/useViolationsTableHelper";
import { TableContext } from "../../index";

function DeviceDetailsTable({ changelogList, deviceId }) {

    const helper = useViolationsTableHelper();
    const { config } = useContext(TableContext);

    const headers = [
        { name: 'RULE NAME', sortKey: 'rule', onClick: () => helper.onRuleNameClick() },
        { name: 'DESCRIPTION', sortKey: 'details', onClick: () => helper.onDetailsClick() },
        { name: 'EXPECTED RESULT', sortKey: 'expectedOutput', onClick: () => helper.onExpectedResultClick() },
        { name: 'USER', sortKey: 'user', onClick: () => helper.onUserClick() },
        { name: 'SEVERITY', sortKey: 'severity', onClick: () => helper.onSeverityClick() },
        { name: 'VALID', sortKey: 'valid', onClick: () => helper.onValidClick() },
        { name: 'GROUP', onClick: () => helper.onGroupClick() },
    ]

    // Client-side search filtering using the searchTerm from TableContext
    const searchTerm = (config.searchTerm || '').toLowerCase();
    const filteredList = searchTerm
        ? changelogList.filter(item => {
            const rule = (item.rule || '').toLowerCase();
            const details = (item.details || '').toLowerCase();
            const user = (item.user || '').toLowerCase();
            const severity = (item.severity || '').toLowerCase();
            return rule.includes(searchTerm) || details.includes(searchTerm) ||
                user.includes(searchTerm) || severity.includes(searchTerm);
        })
        : changelogList;

    return (
        <>
            <Table headers={headers}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <DeviceDetailsTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredList.map((config, index) => <DeviceDetailsTableRow key={index} data={config} index={index}
                        deviceId={deviceId} />)
                )}
            </Table>
            {!config.isLoading && filteredList.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    )


}

function mapStateToProps(state) {
    debug("DeviceDetailsTable mapStateToProps", state);
    const deviceDetailsPage = state.deviceDetailsPage;
    const device = deviceDetailsPage.device;
    return {
        changelogList: deviceDetailsPage.changelogList || [],
        deviceId: device ? device.id : null
    };
}

export default connect(mapStateToProps)(DeviceDetailsTable);
